"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

var _typeof2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/typeof"));

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _lang = _interopRequireDefault(require("@/lang"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _index = _interopRequireDefault(require("@/components/Pagination/index"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _validate = require("@/utils/validate");

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
var _default = {
  name: "organizationCost:view",
  props: ['organizationCode'],
  extends: _PermissionPage.default,
  components: {
    Pagination: _index.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  watch: {
    'addInformationParameter.minAmount': function addInformationParameterMinAmount(newVal, oldVal) {
      if (!(0, _validate.isMoney)(newVal, false, this.numberOfDecimal)) this.addInformationParameter.minAmount = oldVal;
    }
  },
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      agentList: null,
      total: 0,
      listLoading: false,
      addDialogVisible: false,
      channelList: [],
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        channelId: '',
        state: null,
        currency: "",
        netwayCode: null
      },
      addInformationParameter: {
        id: '',
        channelId: '',
        state: '',
        weight: '',
        minAmount: '',
        netwayCode: '',
        currency: "",
        description: '',
        remark: ''
      },
      downloadLoading: false,
      multipleSelection: [],
      numberOfDecimal: 2,
      netwayCodeEnums: [],
      rules: {
        currency: [{
          required: true,
          message: _lang.default.t('channel.currencyText') + " " + _lang.default.t('warningMessage.cannotBeEmpty'),
          trigger: 'blur'
        }],
        state: [{
          required: true,
          message: _lang.default.t("organization.statusText") + " " + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        channelId: [{
          required: true,
          message: _lang.default.t("organization.channelText") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        weight: [{
          required: true,
          message: _lang.default.t("organization.weightingText") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['costStatusOption', 'statusOptions', 'useOptions', 'informationOptions', 'currencyTypeOption', 'netwayCodeOption']), {
    //Show caller input when VUE_APP_SHOW_CALLER_INPUT equals 1
    showCallerInput: function showCallerInput() {
      return process.env.VUE_APP_SHOW_CALLER_INPUT === '1';
    }
  }),
  created: function created() {
    var _this2 = this;

    this.handleNetwayCode(); //If organization code is undefined, return to previous page

    if (this.organizationCode != undefined) {
      this.getList(); //get number of decimal of minAmount

      this.getNumberOfDecimal(); //Get channel list

      this.getPayChannelList(); //Set default weight 50

      this.addInformationParameter.weight = 50;
    } else {
      //Go back to previous webpage
      this.$store.dispatch('tagsView/delView', this.$route).then(function () {
        _this2.$router.go(-1);
      });
    }
  },
  mounted: function mounted() {
    if (this.organizationCode != undefined) {
      this.getList();
    } else {
      //Go back to previous webpage
      this.$router.go(-1);
    }
  },
  methods: {
    handleNetwayCode: function handleNetwayCode() {
      this.netwayCodeEnums = this.$store.getters.netwayCodeEnums;

      if (this.netwayCodeEnums == null || (0, _typeof2.default)(this.netwayCodeEnums) != 'object' || this.netwayCodeEnums.length < 1) {
        this.netwayCodeEnums = this.netwayCodeOption;
      }
    },
    getNetwayCodeByPayChannel: function getNetwayCodeByPayChannel() {
      var _this3 = this;

      this.channelList.forEach(function (status) {
        if (parseInt(status.channelId) == _this3.addInformationParameter.channelId) {
          _this3.addInformationParameter.netwayCode = status.netwayCode;
          return;
        }
      });
    },
    convertNetwayCodeToName: function convertNetwayCodeToName(key) {
      var found = '';
      this.netwayCodeEnums.forEach(function (status) {
        if (status.key == key) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    getList: function getList() {
      var _this4 = this;

      //If organization code is undefined, return to previous page
      if (this.organizationCode == undefined) {
        //Go back to previous webpage and remove tag
        this.$store.dispatch('tagsView/delView', this.$route).then(function () {
          //Go back to previous webpage
          _this4.$router.go(-1);
        });
      } //Get search parameters


      var params = this.getQueryParams();
      this.listLoading = true;

      _httpUtils.default.post("organizationCost", "list", null, params).then(function (res) {
        _this4.list = res.data.rows;
        _this4.total = res.data.total;
      }).finally(function (_) {
        _this4.listLoading = false;
      });

      setTimeout(function () {
        _this4.listLoading = false;
      }, 1 * 1000);
    },
    convertChannelIdToChannelName: function convertChannelIdToChannelName(channelId) {
      var found = '';
      this.channelList.forEach(function (status) {
        if (parseInt(status.channelId) == channelId) {
          found = status.channelName;
          return;
        }
      });
      return found;
    },
    //Initial channel list
    getPayChannelList: function getPayChannelList() {
      var _this5 = this;

      _httpUtils.default.post("payChannel", "getPayChannelOption", null, null).then(function (res) {
        _this5.channelList = res.data;
      });
    },
    //Get search parameter for backend service
    getQueryParams: function getQueryParams() {
      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        organizationCode: this.organizationCode,
        smsType: this.queryParameter.smsType,
        costName: this.queryParameter.costName,
        channelId: this.queryParameter.channelId,
        currency: this.queryParameter.currency,
        state: this.queryParameter.state,
        netwayCode: this.queryParameter.netwayCode
      };
    },
    //Refresh table
    handleFilter: function handleFilter() {
      //Reset the page number of table
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    //Get input parameters for backend service
    getAddInformationParameter: function getAddInformationParameter() {
      return {
        id: this.addInformationParameter.id,
        organizationCode: this.organizationCode,
        channelId: this.addInformationParameter.channelId,
        state: this.addInformationParameter.state,
        weight: this.addInformationParameter.weight,
        description: this.addInformationParameter.description,
        remark: this.addInformationParameter.remark,
        minAmount: this.addInformationParameter.minAmount,
        netwayCode: this.addInformationParameter.netwayCode,
        currency: this.addInformationParameter.currency
      };
    },
    //Handle add organization cost
    handleAdd: function handleAdd() {
      var _this6 = this;

      var _this = this;

      this.$refs['addInformation'].validate(function (valid) {
        if (valid) {
          var params = _this.getAddInformationParameter();

          if (_this.updateChannelFlag) {
            _this6.listLoading = true;

            _httpUtils.default.post("organizationCost", "update", null, params).then(function (res) {
              if (res.code === 200) {
                _this6.$notify({
                  title: _lang.default.t("message.organizationManagementMessage20"),
                  message: res.data,
                  type: "success",
                  duration: 2000
                });
              }

              if (res.code === 500) {
                _this6.$message({
                  message: _lang.default.t('warningMessage.channelCostExistMessage'),
                  type: 'warning'
                });
              }

              _this6.handleResetAdd();

              _this6.handleFilter();

              _this6.listLoading = false;
            }).catch(function (error) {
              _this6.$message({
                message: error.message,
                type: 'error'
              });

              _this6.$refs['addInformation'].clearValidate();
            });

            setTimeout(function () {
              _this6.listLoading = false;
            }, 1 * 1000);
          } else {
            _this6.listLoading = true;

            _httpUtils.default.post("organizationCost", "update", null, params).then(function (res) {
              if (res.code === 200) {
                _this6.$notify({
                  title: _lang.default.t("message.organizationManagementMessage21"),
                  message: res.data,
                  type: "success",
                  duration: 2000
                });
              }

              if (res.code === 500) {
                _this6.$message({
                  message: _lang.default.t('warningMessage.channelCostExistMessage'),
                  type: 'warning'
                });
              }

              _this6.handleResetAdd();

              _this6.handleFilter();

              _this6.listLoading = false;
            }).catch(function (error) {
              _this6.$message({
                message: error.message,
                type: 'error'
              });

              _this6.$refs['addInformation'].clearValidate();
            });

            setTimeout(function () {
              _this6.listLoading = false;
            }, 1 * 1000);
          }
        } else {
          return false;
        }
      });
    },
    //Delete organization cost
    deleteOrganizationCost: function deleteOrganizationCost(organizationCostIds) {
      var _this7 = this;

      _httpUtils.default.post("organizationCost", "batchDelete", null, organizationCostIds).then(function (_) {
        _this7.$message({
          message: _lang.default.t('warningMessage.deleteRecordSuccessMessage'),
          type: 'success'
        });

        _this7.handleFilter();
      }).catch(function (err) {
        _this7.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    //Handle delete selected organization cost
    handleDelete: function handleDelete(id) {
      var _this8 = this;

      this.$confirm(_lang.default.t('warningMessage.deleteChannelCostConfirmMessage'), _lang.default.t('warningMessage.deleteChannelCostMessage'), {
        confirmButtonText: _lang.default.t('common.confirm'),
        cancelButtonText: _lang.default.t('common.cancel'),
        type: 'warning'
      }).then(function () {
        var organizationCostIds = [];
        organizationCostIds.push(id);

        _this8.$nextTick(function (_) {
          _this8.deleteOrganizationCost(organizationCostIds);
        });
      }).catch(function (_) {});
    },
    //Handle batch delete selected organization costs
    handleBatchDelete: function handleBatchDelete() {
      var _this9 = this;

      var _this = this;

      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t('warningMessage.selectRecordToDeleteMessage'),
          type: 'error'
        });
      } else {
        this.$confirm(_lang.default.t('warningMessage.deleteChannelCostConfirmMessage'), _lang.default.t('warningMessage.deleteChannelCostMessage'), {
          confirmButtonText: _lang.default.t('common.confirm'),
          cancelButtonText: _lang.default.t('common.cancel'),
          type: 'warning'
        }).then(function () {
          var organizationCostIds = [];

          for (var item in _this.multipleSelection) {
            organizationCostIds.push(_this.multipleSelection[item].id);
          }

          _this9.$nextTick(function (_) {
            _this9.deleteOrganizationCost(organizationCostIds);
          });
        }).catch(function (_) {});
      }
    },
    //Fill in parameters for updating organization cost
    handleUpdateCheck: function handleUpdateCheck(row) {
      this.addInformationParameter.id = row.id;
      this.addInformationParameter.channelId = parseInt(row.channelId);
      this.addInformationParameter.state = row.state;
      this.addInformationParameter.smsType = row.smsType;
      this.addInformationParameter.weight = row.weight;
      this.addInformationParameter.description = row.description;
      this.addInformationParameter.remark = row.remark;
      this.addInformationParameter.minAmount = row.minAmount;
      this.addInformationParameter.netwayCode = row.netwayCode;
      this.addInformationParameter.currency = row.currency;
      this.addDialogVisible = true;
      this.updateChannelFlag = true;
    },
    //Reset input parameters
    handleReset: function handleReset() {
      this.addInformationParameter.id = null;
      this.addInformationParameter.channelId = '';
      this.addInformationParameter.state = '';
      this.addInformationParameter.weight = 50;
      this.addInformationParameter.description = '';
      this.addInformationParameter.remark = '';
      this.addInformationParameter.minAmount = '';
      this.addInformationParameter.netwayCode = '';
      this.addInformationParameter.currency = "";
    },
    //Reset validate for input parameters
    handleResetAdd: function handleResetAdd() {
      var _this10 = this;

      this.handleReset();
      this.addDialogVisible = false;
      this.updateChannelFlag = false;
      this.$nextTick(function (_) {
        _this10.$refs['addInformation'].clearValidate();
      });
    },
    convertOrgStatus: function convertOrgStatus(key) {
      var found = key;
      this.statusOptions.forEach(function (item) {
        if (item.key == key.toString()) {
          found = item.display_name;
          return;
        }
      });
      return found;
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //Convert currency
    convertCurrencyCodeToName: function convertCurrencyCodeToName(val) {
      if (!this.currencyTypeOption || !this.currencyTypeOption.length) return;
      var currency = this.currencyTypeOption.find(function (currency) {
        return currency.key === val;
      });

      if (currency) {
        return currency.display_name;
      } else {
        return "";
      }
    },
    getNumberOfDecimal: function getNumberOfDecimal() {
      var _this11 = this;

      _httpUtils.default.post("agentCost", "getNumberOfDecimal", {}, null).then(function (res) {
        _this11.numberOfDecimal = res.data.numberOfDecimal;
      }).catch(function (err) {
        _this11.$message({
          message: err.message,
          type: 'error'
        });
      });
    }
  }
};
exports.default = _default;